import {
  ChakraBox,
  ChakraFlex,
  FireflyTertiaryButtonMenu,
} from '@equip.health/ui';

import {
  getZoneNameDisplay,
  supportedIanaTimezones,
} from '~/lib/util/calendar.util';

const TOP_LEVEL_ID = 'availability-rule__set-timezone__timezone-select';

interface TimezoneSelectProps {
  handleSelect: (value: string) => void;
  value: string;
}

const TimezoneSelect = ({ handleSelect, value }: TimezoneSelectProps) => {
  const timezoneOptions = supportedIanaTimezones.map((tz) => ({
    label: getZoneNameDisplay(tz),
    node: tz,
  }));

  return (
    <ChakraFlex align="center" paddingBottom="18px" paddingTop="18px">
      <ChakraBox zIndex={3}>
        <FireflyTertiaryButtonMenu
          buttonId={TOP_LEVEL_ID}
          buttonText={
            timezoneOptions.find(
              (timezoneOption) => timezoneOption.node === value,
            )?.label
          }
          maxWidth="280px"
          onOptionClick={(e) => handleSelect(e)}
          options={timezoneOptions}
        />
      </ChakraBox>
    </ChakraFlex>
  );
};

export default TimezoneSelect;
